<template>
    <a-select mode="multiple" v-model:value="state.value" :placeholder="props.placeholder" @change="changeValue"
        option-filter-prop="label">
        <a-select-option v-for="(item, index) in state.platformList" :key="index" :value="item.id"
            :label="item.platform_abbreviation">{{
                item.platform_abbreviation }}</a-select-option>
    </a-select>
</template>
<script lang="ts" setup>
import { reactive, ref, onMounted, h, watch } from 'vue'
import { message, Modal, Table } from 'ant-design-vue'
import baseService from '@/utils/http/axios'
const emit = defineEmits(['update:value', 'change'])
const props = defineProps({
    value: {
        type: Array,
        default: []
    },
    placeholder: {
        type: String,
        default: '请选择平台'
    }
})
const state = reactive<any>({
    platformList: [],
    value: []
})
onMounted(() => {
    platformList()
})
// 获取平台数据
const platformList = () => {
    // 获取到列表数据
    let requestParam = {
        url: '/admin/v1/platformList',
        method: 'post',
        data: { limit: 'all' }
    }
    baseService(requestParam)
        .then((res) => {
            state.platformList = res.data.list
        })
        .catch((res) => {
            if (res.msg) {
                message.error(res.msg)
            } else {
                message.error('平台列表查询失败,请联系管理员')
            }
        })
}
//改变值
const changeValue = (value: any) => {
    emit('update:value', state.value)
    emit('change', state.value)
}
watch(
    () => props.value,
    (val) => {
        if (val) {
            state.value = val
        }
    },
    {
        deep: true,
        immediate: true
    }
)
</script>
